common.View.create('canvas.blocks.sky.headerAlfa.Block', {

    onDOMLoad() {
        this.initOnScroll();
    },

    initOnScroll() {
        // Sticky header?
        if( !this.element.find('.stickyNavItems').length ) {
            return;
        }

        // Add listener for scroll
        $(window).scroll(() => {
            this.showOrHideElement();
        });

        // Show or hide element on load
        this.showOrHideElement();
    },

    showOrHideElement()
    {
        // Check if footer is in sight
        if (window.scrollY > 0) {
            // Hide element with fade
            this.element.find('.stickyNavItems').addClass('small');
        } else {
            // Show element with fade
            this.element.find('.stickyNavItems').removeClass('small');
        }
    }

});
